<script lang="ts">
    import { onMount } from "svelte";
    import Button from "../components/Button.svelte";

    interface Props {
        ontestaudio: () => void;
        ondone: () => void;
    }

    const { ontestaudio, ondone }: Props = $props();

    let testedAudio = $state(false);

    onMount(() => {
        gtag("event", "page_view", { page_title: "TestAudioScreen" });
    });
</script>

<div class="flex flex-1 flex-col gap-[20px] p-[20px] py-[80px]">
    <h1 class="text-center text-3xl font-semibold drop-shadow-md drop-shadow-black">Test Audio</h1>

    <div class="flex flex-1 flex-col items-center justify-center gap-[20px]">
        {#snippet item(icon: string, text: string)}
            <div class="flex flex-row items-center gap-[10px] drop-shadow-md drop-shadow-black/75">
                <span class="icon">{icon}</span>
                <p class="font-semibold">{text}</p>
            </div>
        {/snippet}

        {@render item("notifications_active", "Turn off Silent Mode")}
        {@render item("dark_mode", "Turn on Do Not Disturb")}
        {@render item("volume_up", "Set volume to 100%")}
    </div>

    <Button
        onclick={() => {
            ontestaudio();
            testedAudio = true;
        }}
        color="var(--color-green-500)">Test Audio</Button
    >
    <Button onclick={ondone} disabled={!testedAudio}>Continue</Button>
</div>
